import Icon from '@components/v2/ui/Icon/Icon';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import { X } from 'lucide-react';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';
import { useModalStyles } from '../modal.styles';
import type { ModalHeaderConfig } from '../modal.types';

interface ModalHeaderProps extends ModalHeaderConfig {
  titleId: string;
  onClose: () => void;
}

const ModalHeader = ({ title, icon, action, titleId, onClose }: ModalHeaderProps) => {
  const { classes } = useModalStyles();
  const { translate } = useTranslation();

  return (
    <Box className={classes.header}>
      <Box id={titleId} className={classes.headerTitle}>
        {icon && <Icon icon={icon} size="md" />}
        {typeof title === 'string' ? (
          <Typography variant="h6" component="h2" noWrap>
            {translate(title as LangEnum)}
          </Typography>
        ) : (
          title
        )}
      </Box>
      {action && <Box className={classes.headerAction}>{action}</Box>}
      <IconButton
        icon={X}
        size="medium"
        onClick={onClose}
        ariaLabel={translate(LangEnum.GLOBAL_CLOSE)}
        testId="modal-close"
      />
    </Box>
  );
};

export default ModalHeader;
